import "core-js/modules/web.dom.iterable";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { stringify } from 'qs';
import keys from 'lodash/keys';
import * as TYPES from './types';
import { extractProductReference } from '~/helpers/extract-helper';
import { fetchProductNav, fetchProduct, fetchProductCarousels } from '~/services/product';
export default {
  fetchProductCarousels(_ref, _ref2) {
    var _this = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref;
      let {
        alias,
        profileId,
        exclude
      } = _ref2;
      const reference = extractProductReference(alias);
      const product = yield fetchProductCarousels(_this, reference, profileId, exclude);
      commit(TYPES.SET_PRODUCT_CAROUSELS, product);
    })();
  },

  fetchProduct(_ref3, _ref4) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref3;
      let {
        alias,
        query,
        profileId
      } = _ref4;
      const reference = extractProductReference(alias);
      const [productNav, product] = yield Promise.all([fetchProductNav(_this2, reference), fetchProduct(_this2, reference, profileId)]);
      const {
        currentLocale
      } = _this2.state.i18n;
      const currentQuery = keys(query).length ? "?".concat(stringify(query)) : '';
      const currentAlias = "".concat(productNav.product.slug, "-").concat(productNav.product.reference, ".htm");

      if (alias !== currentAlias && process.server) {
        _this2.app.context.redirect(301, "/".concat(currentLocale.market, "/").concat(currentLocale.language, "/p/").concat(currentAlias).concat(currentQuery));
      }

      if (productNav.product && productNav.product.redirect_url) {
        if (process.server && productNav.product.redirect_url) {
          _this2.app.context.redirect(301, "".concat(productNav.product.redirect_url).concat(currentQuery));
        } else {
          window.location.href = "".concat(productNav.product.redirect_url).concat(currentQuery);
        }
      }

      commit(TYPES.SET_PRODUCT_NAV, productNav);
      commit(TYPES.SET_PRODUCT, product);
    })();
  }

};